import styled from '@emotion/styled'
import { Box } from '@mui/material'

export const InfoItem = styled(Box)`
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: top;
  padding: 10px 10px 0 10px;
  background-color: #f9f9f9;
  font-weight: 600;
  color: #4f4848;
  border-radius: 6px;
  cursor: pointer;
`

export const InfoTitleItem = styled(Box)`
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: top;
  padding: 10px 10px 0 10px;
  background-color: #f9f9f9;
  font-weight: 600;
  color: #4f4848;
  border-radius: 6px;
  cursor: pointer;
`

export const inputBoxWrapper = {
  display: 'flex',
  gap: '10px',
  alignItems: 'flex-start',
  justifyContent: 'flex-end',
  width: '70%',
}

export const dashWrapperBox = {
  paddingTop: '7px',
}

export const titleStyleSmallScreen = {
  fontWeight: 800,
  fontSize: '1.2rem',
  lineHeight: '18px',
  marginRight: '10%',
}

export const titleStyle = {
  fontWeight: 800,
  fontSize: '1.2rem',
  lineHeight: '18px',
  marginRight: '12%',
}

export const valueBoxWrapper = {
  width: '90px',
}

export const rightHelperTextStyle = {
  '& .MuiFormHelperText-root': {
    color: 'red',
    fontSize: '0.75rem',
    whiteSpace: 'nowrap',
    width: '100%',
    justifyContent: 'flex-end',
    textAlign: 'left',
    direction: 'rtl',
    transform: 'translateX(-10px)',
    maxHeight: '4px',
    minHeight: '4px',
  },
}

export const rightHelperWarningTextStyle = {
  '& .MuiFormHelperText-root': {
    color: 'orange',
    fontSize: '0.75rem',
    whiteSpace: 'nowrap',
    width: '100%',
    justifyContent: 'flex-end',
    textAlign: 'left',
    direction: 'rtl',
    transform: 'translateX(-10px)',
    maxHeight: '4px',
    minHeight: '4px',
  },
}

export const leftHelperTextStyle = {
  '& .MuiFormHelperText-root': {
    color: 'red',
    fontSize: '0.75rem',
    width: '100%',
    justifyContent: 'flex-start',
    textAlign: 'left',
    transform: 'translateX(-10px)',
    lineHeight: 1,
    maxHeight: '4px',
    minHeight: '4px',
  },
}

export const leftHelperWarningTextStyle = {
  '& .MuiFormHelperText-root': {
    color: 'orange',
    fontSize: '0.75rem',
    width: '100%',
    justifyContent: 'flex-start',
    textAlign: 'left',
    transform: 'translateX(-10px)',
    lineHeight: 1,
    maxHeight: '4px',
    minHeight: '4px',
  },
}
